import { render } from "./SectionBanner.vue?vue&type=template&id=fb42eae8"
import script from "./SectionBanner.vue?vue&type=script&lang=js"
export * from "./SectionBanner.vue?vue&type=script&lang=js"
script.render = render

export default script